<template>
  <div>
    <template v-if="windowSize.width < 1024">
      <div
        class="block lg:hidden fixed top-0 z-20 text-white bg-zt-primary-200 flex w-full document--header items-center px-6"
      >
        <button class="mr-auto md:pl-4 text-zt-xl" @click="$router.back()" data-vs-button="go-back">
          <zt-icon name="angle-left" />
        </button>
        <p class="w-full text-center text-zt-lg">
          {{ $t('message.UploadLanding.uploadFile.title') }}
        </p>
      </div>
      <UploadFileMobile />
    </template>
    <template v-else>
      <UploadFileDesktop />
    </template>
  </div>
</template>

<script>

import UploadFileMobile from '../components/UploadFileMobile'
import UploadFileDesktop from '../components/UploadFileDesktop'
import { useWindowResize } from '@sichern/ui-elements' 

export default {

    components:{
      UploadFileMobile,
      UploadFileDesktop
    },
    data(){
      return{
        title: this.$t('message.FileUploadComponent.header.title'),
        headerView: 5,
        showBackButton: true,
        windowSize: useWindowResize(this)
      }
    },
    watch: {

    },
    created(){

    }
}
</script>

<style scoped>
 .document--header {
   height: 64px;
 }
</style>